import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { PostRequest } from "../../../functions/ApiFunctions";

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  const route = all_routes;
  const [loading, setLoading] = useState(false);


  const formSubmit = async (e) => {
    e.preventDefault();
      try {
        setLoading(true);
        const res = await PostRequest("admin-login", { email: email, password: password });
        if (res){
          res?.success ? navigate(route.listUsers) : alert(res?.message || "Login Failed");
        }
      } finally {
        setLoading(false);
      }
    }
  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img" style={{backgroundImage: "url(assets/img/bg-img.jpg)"}}>
          <div className="login-content">
            <form action="index" onSubmit={(e)=>{ formSubmit(e)}}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  {/* <ImageWithBasePath src="assets/img/logo.png" alt="img" /> */}
                  <img src="https://photomagic.io/Phot%20Magic_files/cropped-photomagic.png" alt="logo" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
                <div className="login-userheading">
                  
                  <h3>Sign In</h3>
                  <h4>
                    Access the Photomagic using your email and passcode.
                  </h4>
                </div>
                <div className="form-login mb-3">
                  <label className="form-label">Email Address</label>
                  <div className="form-addons">
                    <input type="text" className="form- control" value={email}
                      onChange={(e) => setEmail(e.target.value)}/>
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                </div>
                <div className="form-login mb-3">
                  <label className="form-label">Password</label>
                  <div className="pass-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className={`fas toggle-password ${
                        isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                      }`}
                      onClick={togglePasswordVisibility}
                    ></span>
                  </div>
                </div>
                {/* <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label>
                      </div>
                      <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="form-login">
                  <button type="submit" className="btn btn-login" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Signing in...
                      </>
                    ) : (
                      'Sign In'
                    )}
                  </button>
                </div>
                {/* <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to={route.users} className="hover-a">
                      {" "}
                      Create an account
                    </Link>
                  </h4>
                </div> */}
                {/* <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div> */}
                {/* <div className="form-sociallink">

                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p>Copyright © 2025  Pure Magic Information Technology Services</p>
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
